import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, MenuItem } from '@blueprintjs/core';
import { UtimacoPacketSwitchActionsType } from 'routes/UtimacoPacketSwitch/UtimacoPacketSwitch.types';

interface Props {
  disabled: boolean;
  context: {
    onActionMenuItemClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    props: {
      showActionMenuItem: boolean,
      hasPrivilegeToCreateNew: boolean;
      hasPrivilegeToDelete: boolean;
      hasPrivilegetoView: boolean;
    }
  };
}

const UtimacoPacketSwitchListGridActionMenu: FunctionComponent<Props> = ({
  disabled,
  context: {
    onActionMenuItemClick,
    props: {
      showActionMenuItem,
      hasPrivilegetoView,
      hasPrivilegeToCreateNew,
      hasPrivilegeToDelete,
    },
  },
}: Props) => {
  const { t } = useTranslation();

  return (
    <Menu>
      {hasPrivilegetoView && showActionMenuItem && (
        <MenuItem
          id={UtimacoPacketSwitchActionsType.View}
          onClick={onActionMenuItemClick}
          disabled={disabled}
          text={t('ss8Distributors.grid.view')}
        />
      )}
      {hasPrivilegeToCreateNew && showActionMenuItem && (
        <MenuItem
          id={UtimacoPacketSwitchActionsType.Edit}
          onClick={onActionMenuItemClick}
          disabled={disabled}
          text={t('ss8Distributors.grid.edit')}
        />
      )}
      {hasPrivilegeToDelete && showActionMenuItem && (
        <MenuItem
          id={UtimacoPacketSwitchActionsType.Delete}
          onClick={onActionMenuItemClick}
          disabled={disabled}
          text={t('ss8Distributors.grid.delete')}
        />
      )}
    </Menu>
  );
};

export default UtimacoPacketSwitchListGridActionMenu;
